<template>
    <div class="otp-table" :class="tableHeight > 0 ? 'opt-table-with-table-height' : '' " v-if="tableHeight !== 0">
        <m-new-table class="el-table-box"  ref="mNewTable"
            @row-click='newTablerowClick'
            v-if="tableConfig.tableCut?tableConfig.tableCut:false"
            :tableConfig="tableConfig" :loading="loading"
            :popPrefix="popPrefix" :tableData="tableData"
            :tableList="tableList"
            :columnsWidthConfig="columnsWidthConfig"
            :tableHeight="tableHeight"
            @header-dragend="(data) => $emit('header-dragend', data)"
            @element-change="(data) => $emit('element-change', data)"
            @btn-event="btnEvent"
            @onSelectionChange='handleSelectionChange'
            @row-db-click="rowDBclick"
            @btnClick="(val, index, row, prop,item) => $emit('btnClick', val, index, row, prop,item)"
            @btnRightClick="(val, index, row, prop) => $emit('btnRightClick', val, index, row, prop)"
            >
            <template v-slot:editSlot="scope">
                <slot name="editSlot" v-bind="scope"></slot>
            </template>
            <template v-slot:customTableCell="scope">
                <slot name="customTableCell" v-bind="scope"></slot>
            </template>
        </m-new-table>
        <el-table class="el-table-box" v-else ref='moduleTable' :data="tableData2" border tooltip-effect='dark' v-loading="loading"
                @selection-change="handleSelectionChange" :height="tableHeight > 0 ? tableHeight : tableConfig.height" :style="`height: ${tableHeight}px;`" @sort-change="sortChange" @row-click='rowClick' @row-dblclick="rowDBclick"
                @expand-change="handleExpandChange" :row-key="getRowKeys" :expand-row-keys="expandsRowkeys" @select="select" @select-all="selectAll"
                :row-class-name="tableRowClassName" @cell-dblclick="handleCellDblclick" @header-dragend="headerDragendHandler">
            <el-table-column type="selection" width="40" :fixed="tableConfig.fixedSeletionColumn?true:false" v-if="tableConfig.selectBtn" :reserve-selection="tableConfig.reserveSelection"></el-table-column>
            <el-table-column v-if="tableConfig.expandTable" type="expand">
                <template slot-scope="props">
                    <slot name="expand-table-content" :expandProps="props.row"></slot>
                </template>
            </el-table-column>
            <el-table-column v-for="(item, index) in columnsList"
                             :class-name="`col-prop-${item.prop}`"
                             :key="item.type === 'multiHeader' ? Math.random() : index" :prop='item.prop' :label='item.label' :sortable="item.sort" :min-width="item.width?item.width : ''"
                             :show-overflow-tooltip="_.get(item, 'show-overflow-tooltip', true)"
                             :fixed="item.fixedColumn==undefined ? false : (item.fixedColumn=='left' ? 'left' : false || item.fixedColumn=='right' ? 'right' : false) "
                             :align="item.align || ''">
                <template v-slot:header="scope">
                    <span>
                        <span class="table-header-mustFill" v-if="item.mustFill">* </span>
                        {{scope.column.label}}
                    </span>
                    <el-tooltip v-if="item.info" class="item" effect="dark" placement="bottom">
                            <div slot="content" v-html="item.info"></div>
                            <i class="el-icon-question" style="color: #f96c5f"></i>
                    </el-tooltip>
                </template>
                <template slot-scope="scope">
                    <template v-if="item.type === 'custom'">
                        <slot name="customTableCell" v-bind="{ ...scope, col: item }" />
                    </template>
                    <div v-else-if='item.type === "photos"'>
                        <div v-if='scope.row.showPhotos' style="line-height: 0px;">
                            <img src="@/assets/photos.png" @click.stop='$emit("btnEvent", "photos", scope.row)' @dblclick.stop="" style="width: 20px; cursor: pointer;">
                        </div>
                        <div v-else-if="scope.row.noShowPhotos"></div>
                        <div v-else>
                            <el-button size="mini" type='text' @click.stop='$emit("btnEvent", "upload", scope.row)' @dblclick.stop="" v-if='item.ifHas' v-has='item.ifHas'>
                                {{$translate('component.E202007310005', { defaultText: '上传' })}}
                            </el-button>
                            <el-button size="mini" type='text' @click.stop='$emit("btnEvent", "upload", scope.row)' @dblclick.stop="" v-else>
                                {{$translate('component.E202007310005', { defaultText: '上传' })}}
                            </el-button>
                        </div>
                    </div>
                    <div v-else-if="item.type === 'link'">
                        <a :href="scope.row[item.prop]" target="_blank">{{ scope.row.linkName || scope.row[item.prop] }}</a>
                    </div>
                    <div v-else-if="item.type === 'trajectory'">
                         <div style="line-height: 0px;">
                            <img src="@/assets/gps.png" @click.stop='$emit("btnEvent", "trajectory", scope.row)' @dblclick.stop="" style="width: 20px; cursor: pointer;">
                        </div>
                    </div>
                    <div v-else-if="item.type === 'clickable'">
                        <span
                            class="col-clickable"
                            type="text"
                            size="mini"
                            @click.stop="$emit('btnClick', scope.row[item.prop], scope.$index, scope.row, item.prop)">
                            {{ scope.row[item.prop] }}
                        </span>
                    </div>
                    <div v-else-if="item.type === 'button'">
                        <el-button
                            type="text"
                            size="mini"
                            @contextmenu.prevent.native="$emit('btnRightClick', scope.row[item.prop], scope.$index, scope.row, item.prop)"
                            @click.stop="$emit('btnClick', scope.row[item.prop], scope.$index, scope.row, item.prop)">
                            {{ scope.row[item.prop] }}
                        </el-button>
                    </div>
                    <div v-else-if='item.type === "detail"'>
                        <el-button size="mini" v-if="!scope.row[item.emitEvent + 'Hidden']" type='text'
                            @click.stop='$emit("btnEvent", item.emitEvent || "detail", scope.row)' @dblclick.stop="">
                            {{item.buttonName || $translate('component.E1202104121763', { defaultText: '明细' })}}
                        </el-button>
                    </div>
                    <div v-else-if="item.type === 'select' && item.differentStatus">
                        <span :style="getColorByDifferentStatus(item, scope.row)">
                            {{item.type!=='select'&&item.type!=='cascader'?scope.row[item.prop]:selectToNormal(item, scope.row)}}
                        </span>
                    </div>
                    <div v-else-if="item.type === 'errorTip'">
                        <span v-if="scope.row[item.prop]" style="color: red;">
                            <i class="el-icon-warning"></i>
                            {{ scope.row[item.prop] }}
                        </span>
                    </div>
                    <template v-else>
                        {{item.type!=='select'&&item.type!=='cascader'?scope.row[item.prop]:selectToNormal(item, scope.row)}}
                    </template>
                </template>
                <template v-if="item.type === 'multiHeader'">
                    <el-table-column
                        v-for="(sonItem, sonIndex) in item.subColumns"
                        :key="sonItem.prop + sonIndex"
                        :prop='sonItem.prop'
                        :label='sonItem.label'
                        :sortable="sonItem.sort"
                        :min-width="sonItem.width?sonItem.width : ''"
                        :show-overflow-tooltip="_.get(sonItem, 'show-overflow-tooltip', true)"
                        >
                    </el-table-column>
                </template>
            </el-table-column>
            <el-table-column
                :width="tableConfig.leftWidth?tableConfig.leftWidth : ''"
                v-if="tableConfig.leftOperation"
                fixed="right"
                :label="$translate('component.E202006152352', { defaultText: '操作' })"
                align="center">
                <template slot-scope="scope">
                    <div class="action">
                        <template v-if="tableConfig.hasMaxBtnNum">
                            <template v-if="tableConfig.action.filter(el => !scope.row.hiddenEvent.includes(el.event)).length <= +maxOperationBtnNum">
                                <span v-for="(item, index) in tableConfig.action.filter(el => !scope.row.hiddenEvent.includes(el.event))" :key="index"
                                :class="{pad:!([].concat(scope.row.hiddenEvent).includes(item.event))}">
                                    <el-button
                                        size="mini"
                                        v-if="typeof item.show === 'function'? item.show(scope.row) : (item.show === false?false:true)"
                                        @click.stop=btnEvent(scope.row,item.event) :type=item.type>
                                        {{item.label}}
                                    </el-button>
                                </span>
                            </template>
                            <template v-else>
                                <span v-for="(item, index) in (tableConfig.action.filter(el => !scope.row.hiddenEvent.includes(el.event))). slice(0, maxOperationBtnNum)" :key="index"
                                    v-show="typeof item.show === 'function'? item.show(scope.row) : (item.show === false?false:true)"
                                    :class="{pad:!([].concat(scope.row.hiddenEvent).includes(item.event))}">
                                    <el-button
                                        size="mini"
                                        @click.stop=btnEvent(scope.row,item.event) :type=item.type>
                                        {{item.label}}
                                    </el-button>
                                </span>
                                <el-dropdown class="more-btn">
                                    <span class="el-dropdown-link mainColor">{{$translate('component.E202011270001', { defaultText: '更多' })}}</span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item v-for="(item, index) in (tableConfig.action.filter(el => !scope.row.hiddenEvent.includes(el.event))).slice(maxOperationBtnNum)"
                                            :key="item.event + index" @click.native=btnEvent(scope.row,item.event)>
                                                <el-button size="mini" :type=item.type v-if="typeof item.show === 'function'? item.show(scope.row) : (item.show === false?false:true)">
                                                    {{item.label}}
                                                </el-button>
                                        </el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </template>
                        <template v-else>
                            <span v-if="!tableConfig.customBtn">
                                <span
                                    v-for="(item, index) in tableConfig.action"
                                    :key="index">
                                    <span v-if="item.ifHas" v-has="item.ifHas" :class="{pad:!([].concat(scope.row.hiddenEvent).includes(item.event))}"
                                        v-show="typeof item.show === 'function'? item.show(scope.row) : (item.show === false?false:true)">
                                        <el-button
                                            size="mini"
                                            @click.stop=btnEvent(scope.row,item.event) :type=item.type
                                            v-if="!([].concat(scope.row.hiddenEvent).includes(item.event))">
                                            {{item.label}}
                                        </el-button>
                                    </span>
                                    <span v-else :class="{pad:!([].concat(scope.row.hiddenEvent).includes(item.event))}"
                                        v-show="typeof item.show === 'function'? item.show(scope.row) : (item.show === false?false:true)">
                                        <el-button
                                            size="mini"
                                            @click.stop=btnEvent(scope.row,item.event) :type=item.type
                                            v-if="typeof item.show === 'function'? item.show(scope.row) : (item.show === false?false:!([].concat(scope.row.hiddenEvent).includes(item.event)))">
                                            {{item.label}}
                                        </el-button>
                                    </span>
                                </span>
                            </span>
                            <template v-else>
                                <span v-for="(item, index) in tableConfig.action" :key="index">
                                    <span v-for="(child,i) in item" :key="i">
                                        <span v-if="item.ifHas" v-has="item.ifHas">
                                            <el-button size="mini" @click.stop=btnEvent(scope.row,child.event) :type=child.type
                                            v-if="typeof item.show === 'function'? item.show(scope.row) : (item.show === false?false:child.displayCode===scope.row[tableConfig.btnDisplayCredentials[index]])">
                                                {{child.label}}
                                            </el-button>
                                        </span>
                                        <template v-else>
                                            <el-button size="mini" @click.stop=btnEvent(scope.row,child.event) :type=child.type
                                               v-if="typeof item.show === 'function'? item.show(scope.row) : (item.show === false?false:child.displayCode===scope.row[tableConfig.btnDisplayCredentials[index]])">
                                                {{child.label}}
                                            </el-button>
                                        </template>
                                    </span>
                                </span>
                            </template>
                            <el-dropdown v-if="tableConfig.hasMoreAction">
                                <span class="el-dropdown-link mainColor">
                                    {{$translate('component.E202011270001', { defaultText: '更多' })}}
                                    <i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-for="(item, index) in tableConfig.MoreAction" :key="index" v-show="!!isShow(index, scope.row.showIndex)">
                                        <span v-if="item.ifHas" v-has="item.ifHas">
                                            <el-button size="mini" @click='moreEvent(scope.row,index)' :type=item.type
                                                v-if="typeof item.show === 'function'? item.show(scope.row) : (item.show === false?false:true)">
                                                {{item.label}}
                                            </el-button>
                                        </span>
                                        <template v-else>
                                            <el-button size="mini" @click='moreEvent(scope.row,index)' :type=item.type
                                                v-if="typeof item.show === 'function'? item.show(scope.row) : (item.show === false?false:true)">
                                                {{item.label}}
                                            </el-button>
                                        </template>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import _ from '@/components/lots/utils';
import { dictWithUrl } from '@/components/lots/api';
import mNewTable from '../mNewTable';
import store from '@/store/index';
import { I18nMixins } from '@/components/utils/i18n';

export default {
    name: 'mTable',
    mixins: [I18nMixins],
    components: { mNewTable },
    data() {
        return {
            columnsList: [],
            ruleForm: {},
            initTableColumns: this.tableConfig.columns,
            maxOperationBtnNum: this.tableConfig.maxBtnNum || 3,
            expandsRowkeys: [],
            selectedRowsData: [],
            tableData2: []
        };
    },
    props: {
        tableHeight: {
            type: Number,
            default: () => -1
        },
        tableConfig: Object,
        popPrefix: String,
        longPrefix: String,
        tableData: {
            type: Array
        },
        loading: {
            type: Boolean,
            default() {
                return true;
            }
        },
        verification: {
            type: Object,
            default() {
                return {};
            }
        },
        tableList: {
            type: String,
            default() {
                return '';
            }
        },
        columnsWidthConfig: Object
    },
    methods: {
        getColorByDifferentStatus(item, scope) {
            const background = `background: ${item.differentStatus[scope[item.prop]]};`;
            const defaultStyle = `display: inline-block;color: #fff;width: 100%;font-family: PingFangSC-Semibold;border-radius: 4px;font-weight: 600;`;
            return `${defaultStyle}${background}`;
        },
        sortChange(props) {
            this.$emit('sortChange', props);
        },
        handleBtnPermissionsList() {
            if (this.tableConfig.action && this.tableConfig.hasMaxBtnNum) {
                const hasList = {};
                store.getters.btnPermissions.forEach((item) => {
                    hasList[item] = true;
                });
                this.tableConfig.action = this.tableConfig.action.filter(item => {
                    if (hasList[item.ifHas] || !item.ifHas) {
                        return item;
                    }
                });
            }
        },
        tableRowClassName({ row }) {
            // row.defaultRowClass 默认高亮
            if (this.selectedRowsData.includes(row) || row.defaultRowClass) {
                return row.rowClass || 'highlight-row';
            }
            if (row.forwardTrainNum) {
                return 'forwardTrainNum-row';
            }
        },
        addRow() {
            // 新增一行，并进入行内编辑模式
            this.$refs.mNewTable.addRow();
        },
        getRowKeys(row) {
            if (!row.expandsRandomKey) row.expandsRandomKey = row.id + Math.random().toString().substr(-10);
            if (this.tableConfig.reserveSelection) row.expandsRandomKey = row.id;
            return row.expandsRandomKey;
        },
        handleSelectionChange(selection) {
            this.selectedRowsData = selection;
            this.$emit('onSelectionChange', selection);
        },
        rowDBclick(row) {
            this.$emit('row-db-click', row);
        },
        _toFirstCharUpper(str) {
            return _.isString(str) ? str[0].toUpperCase() + str.substr(1) : '';
        },
        btnEvent(selection, event) {
            this.$emit(`btn${this._toFirstCharUpper(event)}`, selection);
            this.$emit('btnEvent', event, selection);
            const eTable = this.$refs.mNewTable || this;
            if (event !== 'edit') {
                eTable.$refs.moduleTable.clearSelection();
                eTable.$refs.moduleTable.toggleRowSelection(selection);
            }
        },
        moreEvent(selection, index) {
            this.$emit('moreAction', selection, index);
        },
        isShow(index, showIndexs) {
            if (typeof showIndexs === 'object') {
                if (showIndexs.length > 0) {
                    let temp = false;
                    showIndexs.forEach(sIndex => {
                        if (sIndex === index) {
                            temp = true;
                        }
                    });
                    return temp;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        },
        newTablerowClick(rows) {
            this.$emit('row-click', rows);
        },
        rowClick(rows) {
            rows.checked = !rows.checked;
            this.$refs.moduleTable.toggleRowSelection(rows, rows.checked);
            this.$emit('row-click', rows);
        },
        // 重新配置列宽度
        resetColumnWidth(columnsList) {
            this.columnsWidthConfig && Object.keys(this.columnsWidthConfig).forEach(key => {
                const col = columnsList.find(e => e.prop === key);
                if (col) {
                    col.width = this.columnsWidthConfig[key];
                }
            });
            return columnsList;
        },
        // 下拉框字典查询
        getOptionList(columnsList) {
            const optionList = [];
            const numList = [];
            columnsList.map((columns, index) => {
                if (columns.optionNum) {
                    optionList.push(columns.optionNum);
                    numList.push(index);
                }
            });
            if (optionList.length !== 0) {
                const params = {
                    dictCodes: optionList.join(','),
                    tenantCode: this.currentTenant.tenantCode
                };
                dictWithUrl(params).then(list => {
                    const optiondata = optionList.map(num => {
                        const option = [];
                        for (const key in list.data[num]) {
                            if (list.data[num].hasOwnProperty(key)) {
                                option.push({ 'value': key, 'label': _.get(list, `data.${num}.${key}`, '') });
                            }
                        }
                        return option;
                    });
                    numList.map((data, index) => {
                        columnsList[data].options = optiondata[index];
                    });
                });
            }
            this.tableData2 = [];
            this.columnsList = this.resetColumnWidth(columnsList);
            this.dataInit();
        },
        dataInit(list) {
            if (list) {
                this.tempTableData = _.clone(list);
            }
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                this.$nextTick(() => {
                    this.tableData2 = this.tempTableData;
                });
            }, 50);
        },
        selectToNormal(col, row) {
            // 为空，为0，为空数组时返回''
            if ((!row[col.prop] && row[col.prop] !== 0) || (_.isArray(row[col.prop]) && row[col.prop].length === 0)) {
                return '';
            }
            // 下拉框变为正常时显示值的改变
            let result = null;
            if (col.type === 'select') {
                if (_.isArray(row[col.prop])) {
                    result = row[col.prop].map(val => {
                        const options = _.get(col, 'options', []);
                        return _.get(options.find(item => item.value === val || item.label === val), 'label', '');
                    }).join(',');
                } else {
                    const options = _.get(col, 'options', []);
                    result = _.get(options.find(item => item.value === row[col.prop] || item.label === row[col.prop]), 'label', '');
                }
            } else if (col.type === 'addressSelect') {
                result = row[col.labelCn];
            } else {
                result = row[col.prop];
            }
            return result || '';
        },
        handleExpandChange(row, expandedRows) {
            var that = this;
            that.expandsRowkeys = [];
            if (row && expandedRows.length) {
                that.expandsRowkeys.push(row.expandsRandomKey);
            }
        },
        handleCellDblclick(row, column, cell, event) {
            this.$emit('onCellDblclick', row, column, cell, event);
        },
        select(selection, rows) {
            this.$emit('select', selection, rows);
        },
        selectAll(selection) {
            this.$emit('selectAll', selection);
        },
        headerDragendHandler(newWidth, oldWidth, column, event) {
            this.$emit('header-dragend', { width: newWidth, property: column.property });
        }
    },
    watch: {
        tableData: function(list) {
            this.dataInit(list);
            if (list.length && this.$refs.moduleTable) {
                this.$refs.moduleTable.doLayout();
            }
        },
        tableList: function (list) {
            const datas = list.split(',');
            const columnsList = [];
            const initTableColumnsMap = _.clone(this.initTableColumns).reduce((result, o) => {
                result[o.label] = o;
                return result;
            }, {});
            datas.forEach(o => {
                if (initTableColumnsMap[o]) {
                    columnsList.push(initTableColumnsMap[o]);
                }
            });
            this.getOptionList(columnsList);
        }
    },
    computed: {
        ...mapGetters(['currentTenant']),
        _() {
            return _;
        }
    },
    created() {
        this.handleBtnPermissionsList();
    }
};
</script>
<style lang="less">
    .otp-table {
        &.opt-table-with-table-height {
            .el-table__body-wrapper {
                min-height: calc(100% - 36px);
                max-height: calc(100% - 36px);
            }
        }
        .el-table-box{
            border-bottom: solid 1px #EBEEF5;
        }
        .module-table {
            margin: 12px 0;
        }
        .action{
            .el-button{
                flex: 1;
            }
        }
        .el-table__body tr.selected-row>td {
            background: #F1F8FA !important;
        }
        .el-table__body tr.highlight-row {
            background: #e6f8f9;
        }
        .error-active input{
            border-color: red;
        }
        .el-table__body tr.forwardTrainNum-row>td {
            background: #fff7f4;
        }
        th .cell .el-input {
            display: block;
            line-height: 28px;
            padding: 0;
            margin-top: 6px;
        }
        th .cell .filter-input{
            line-height: 24px;
            .el-input__inner{
                height: 24px;
                line-height: 24px;
            }
        }
        td .cell {
            min-height: 23px;
        }
        .self-define-input{
            display: block
        }
        .filter-box{
            height: 28px;
            display: block;
            border-bottom: 1px solid #EBEEF5;
        }
        .mainColor{
            color: #00bcbf;
        }
        .action {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .pad{
                padding:0 8px;
            }
            .more-btn {
                line-height: 22px;
                cursor: pointer;
            }
        }
        .col-clickable {
            color: #00BCBF;
            cursor: pointer;
        }
    }
</style>
